import React, { useMemo } from "react";
import { WEB_SPORTS_MAP } from "../../constants";

export interface FiltersProps {
  filterType: string;
  onSelectFilter(filter: any): void;
  sportKey: string;
}

interface FilterType {
  key: string;
  name: string;
}

const Filters = (props: FiltersProps) => {
  const { filterType, onSelectFilter, sportKey } = props;

  const currentSportObj = WEB_SPORTS_MAP[sportKey];

  const FilterTypes = useMemo(
    () =>
      (currentSportObj?.filters ?? []).filter(
        (ft) => !ft.key.includes("2H") && !ft.key.includes("2P") && !ft.key.includes("3P")
      ),
    [sportKey]
  );

  const selectedIndex = FilterTypes.findIndex((ft: FilterType) => ft.key === filterType);

  return (
    <>
      {FilterTypes.map((ft: FilterType, index: number) => (
        <div
          className={`rotoql-chart__filters-item${index === selectedIndex ? "-selected" : ""}`}
          key={index}
          onClick={() => onSelectFilter(ft)}
        >
          {ft.name}
        </div>
      ))}
    </>
  );
};

export default Filters;
